// extracted by mini-css-extract-plugin
export default {"modalBody":"modalBody-YzN3H","body":"body-qY8Ib"};